import { Box, BoxProps, ButtonNew, ColorOptions, IconButton, Spacer } from '@jfs/ui-new'
import { Colors } from '../../../util/util'

const getEditDownloadView = (
  itemData: any,
  editConfig: (data: any) => void,
  deleteReportFile: (data: any) => void,
  styles: BoxProps,
) => {
  const onDelete = () => {
    deleteReportFile(itemData)
  }

  const onEditConfig = () => {
    editConfig(itemData)
  }
  return (
    <Box {...styles} flexDirection={'row'} marginRight={120}>
      <ButtonNew
        textType={'bodyMedium12'}
        borderWidth={1}
        borderColor={'TRANSPARENT'}
        borderRadius={4}
        titleColor={Colors.REPORT_PRIMARY}
        height={32}
        color={Colors.DISABLED_PRIMARY}
        hoverColor={'GREY_MATTE' as ColorOptions}
        title={'Edit Configuration'}
        icon={'EDIT'}
        iconPaddingRight={'6'}
        onPress={onEditConfig}
        testID="editConfigAction"
        underlayColor={'ALTO_DISABLED' as ColorOptions}
        disabled={itemData?.status === 'In Progress' || itemData?.status === 'Failed'}
      />
      <Spacer direction={'horizontal'} size={16} />
      <Box
        bg={Colors.DISABLED_PRIMARY as ColorOptions}
        borderRadius={6}
        height={32}
        alignItems={'center'}
        w={32}
        justifyContent={'center'}>
        <IconButton
          testID="deleteAction"
          onPress={onDelete}
          id={'DELETE'}
          size={14}
          color={Colors.REPORT_PRIMARY as ColorOptions}
        />
      </Box>
    </Box>
  )
}

export { getEditDownloadView }
